import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#196e2e',
    pc: {
        background: '/features/f-dining-20261109/pc_bg.jpg',
        overlay: 'rgba(25, 110, 46, 0.85)',
        eyebrow: '求人特集',
        titleLines: ['株式会社', 'f.dining'],
        contentsColor: '#196e2e',
    },
    hero: {
        image: '/features/f-dining-20261109/hero.jpg',
        alt: '株式会社f.dining 求人特集 表参道のレストランDEK 年間休118日＊スタッフ募集！',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: '『' },
            { text: '青果物をもっと身近に', accent: true },
            { text: '』' },
            { text: 'をテーマに', breakBefore: true },
        ],
        paragraphs: [
            { text: '表参道駅から徒歩4分の' },
            { text: '『DEK 青山』は、老舗青果仲卸の', breakBefore: true },
            { text: '船昌グループが手がける、', breakBefore: true },
            { text: '旬の国産野菜とフルーツを主役にした', breakBefore: true },
            { text: 'ダイニングレストランです。', breakBefore: true },
        ],
    },
    thumbnail: {
        image: '/features/f-dining-20261109/top_sub.jpg',
        alt: '野菜を扱うスタッフ、ドリンクとデザート、店内の写真',
    },
    featuresTitle: ['f.diningで働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['専門のバイヤーが厳選した', '国産の野菜や果物'],
            body: [
                '日本の食材を使うことは、日本の農業を守り、未来の後継者を育むことにつながると考え、日本全国の農家さんから専門のバイヤーが厳選した国産の野菜や果物をふんだんに扱っています。',
            ],
            image: '/features/f-dining-20261109/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['挑戦したいことを', '口に出しやすい雰囲気'],
            body: [
                '若手のスタッフにも、成長と挑戦の機会があります。新しいことに前向きな人が多いからこそ、挑戦したいことを口に出しやすい雰囲気です。',
            ],
            image: '/features/f-dining-20261109/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['旬の青果を主役に、', '日々メニューを磨く'],
            body: [
                'メニューは、専属のシェフやパティシエが旬の青果をいかに美味しく届けられるかを日々研究し、既存のコンセプトを大切にしながらも、固定化されたメニューに縛られず、店舗ごとの特色を活かして開発しています。',
            ],
            image: '/features/f-dining-20261109/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    jobs: {
        eyebrow: 'pickup',
        title: ['f.dining 求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'dek',
                categoryLabel: 'DEK',
                variant: 'list',
                description:
                    '表参道のレストラン。副店長候補・料理長候補・ホール・キッチンスタッフを募集。2023年2月にオープンし、全94席の2フロア構成で営業しています。',
                jobs: [
                    {
                        offerId: '63473',
                        badgeLabel: '洋食・西洋料理,カフェ｜店長・店長候補',
                        title: '【表参道のレストランで副店長を募集！】母体安定＊みなし残業なし＊労働環境◎',
                        brandName: 'DEK DEK青山',
                        brandLogo: '/features/f-dining-20261109/logo_01.jpg',
                        salary: '28~34',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/f-dining-20261109/job_card_01_01.jpg',
                        href: 'https://foods-labo.com/offers/63473',
                        analyticsLabel: 'CT_Jobinformation_求人例-DEK-1st',
                    },
                    {
                        offerId: '121761',
                        badgeLabel: '洋食・西洋料理,カフェ｜料理長・料理長候補',
                        title: '《ジャンルレスで素材の可能性を引き出す料理！》年間休118日＊労働環境安定',
                        brandName: 'DEK DEK青山',
                        brandLogo: '/features/f-dining-20261109/logo_01.jpg',
                        salary: '31~42',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/f-dining-20261109/job_card_01_02.jpg',
                        href: 'https://foods-labo.com/offers/121761',
                        analyticsLabel: 'CT_Jobinformation_求人例-DEK-2nd',
                    },
                    {
                        offerId: '61190',
                        badgeLabel:
                            '洋食・西洋料理,カフェ｜レストランサービス・ホールスタッフ',
                        title: '《お洒落な店内＊残業少なめ＊年間休118日》ホールスタッフ募集／表参道',
                        brandName: 'DEK DEK青山',
                        brandLogo: '/features/f-dining-20261109/logo_01.jpg',
                        salary: '23~31',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/f-dining-20261109/job_card_01_03.jpg',
                        href: 'https://foods-labo.com/offers/61190',
                        analyticsLabel: 'CT_Jobinformation_求人例-DEK-3rd',
                    },
                    {
                        offerId: '110994',
                        badgeLabel: '洋食・西洋料理,カフェ｜キッチンスタッフ',
                        title: '【キッチン募集】表参道＊年間休118日＊残業少なめ＊幅広く料理学べます！',
                        brandName: 'DEK DEK青山',
                        brandLogo: '/features/f-dining-20261109/logo_01.jpg',
                        salary: '22~34',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/f-dining-20261109/job_card_01_04.jpg',
                        href: 'https://foods-labo.com/offers/110994',
                        analyticsLabel: 'CT_Jobinformation_求人例-DEK-4th',
                    },
                ],
            },
        ],
    },
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
}
